// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3gaR8","col":"Table_col__H-tW6","fulfillmentStatus":"Table_fulfillmentStatus__2WJRh","emailCol":"Table_emailCol__3hH6J"};